import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { useDispatch } from "react-redux";
import axios from "../../../axios/AxiosInterceptors";
import { onError } from "../../../store/actions/popupActions";

const TransactionComments = (props) => {

    const dispatch = useDispatch();
    const [comments, setComments] = useState();

    useEffect(() => {
        retrieveComments(props.accountId, props.transactionType, props.transactionId);
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props])

    const retrieveComments = async (accountId, transactionType, transactionId) => {
        await trackPromise(axios.get("/capacity/account/" + accountId + "/transactions/" + transactionType + "/" + transactionId + "/comment").then(response => {
            setComments(response.data);
        }).catch(error => {
            dispatch(onError(error));
        }))
    }

    return (
        <React.Fragment>
            <Typography variant="h6" align="center" style={{ marginTop: 50 }}>Comments</Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Timestamp</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {comments && comments.length > 0 &&
                        comments.map(r => {
                            return (
                                <TableRow key={r.id}>
                                    <TableCell>{r.agentName}</TableCell>
                                    <TableCell>{r.timestamp}</TableCell>
                                    <TableCell>{r.text}</TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
        </React.Fragment>
    );

}

export default TransactionComments;